import { remove } from 'ramda';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';
import { views } from './constants';

export const initialState = {
	view: views.OVERVIEW,
	campaignId: null,
	contextUser: null,
	hasSubordinates: false,
	structures: [],
	history: [],
};

const reducerMap = {
	[types.CHANGE_VIEW]: (state, { payload }) => {
		const { history, ...lastValues } = state;
		const { view, campaignId, contextUser, structures, hasSubordinates = false } = payload;

		return {
			view,
			campaignId,
			structures,
			contextUser,
			hasSubordinates,
			history: [{ ...lastValues }, ...history],
		};
	},
	[types.RETURN_TO_PREVIOUS_VIEW]: (state) => {
		return {
			...state.history[0],
			history: remove(0, 1, state.history),
		};
	},
};

export default handleActions(reducerMap, initialState);
